var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuVault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_777_154)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.625C0.5 2.7321 1.27232 2 2.21429 2H13.6429C14.5848 2 15.3571 2.7321 15.3571 3.625V4.16667H15.4333C16.0224 4.16667 16.5 4.65169 16.5 5.25C16.5 5.84831 16.0224 6.33333 15.4333 6.33333H15.3571V9.58333H15.4333C16.0224 9.58333 16.5 10.0684 16.5 10.6667C16.5 11.265 16.0224 11.75 15.4333 11.75H15.3571V12.2917C15.3571 13.1846 14.5848 13.9167 13.6429 13.9167H13.0714C13.0714 14.515 12.5939 15 12.0048 15H11.8524C11.2633 15 10.7857 14.515 10.7857 13.9167H5.07143C5.07143 14.515 4.59387 15 4.00476 15H3.85238C3.26328 15 2.78571 14.515 2.78571 13.9167H2.21429C1.27232 13.9167 0.5 13.1846 0.5 12.2917V3.625ZM2.5 5.58036V9.83631C2.5 10.1568 2.75584 10.4167 3.07143 10.4167C3.38702 10.4167 3.64286 10.1568 3.64286 9.83631V5.58036C3.64286 5.25983 3.38702 5 3.07143 5C2.75584 5 2.5 5.25983 2.5 5.58036ZM8.36667 10.4167C9.83943 10.4167 11.0333 9.2041 11.0333 7.70833C11.0333 6.21256 9.83943 5 8.36667 5C6.89391 5 5.7 6.21256 5.7 7.70833C5.7 9.2041 6.89391 10.4167 8.36667 10.4167ZM8.36667 9.13327C7.5918 9.13327 6.96365 8.49531 6.96365 7.70833C6.96365 6.92136 7.5918 6.28339 8.36667 6.28339C9.14153 6.28339 9.76969 6.92136 9.76969 7.70833C9.76969 8.49531 9.14153 9.13327 8.36667 9.13327Z",
    fill: "#5D6588"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_777_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVault);
export default __webpack_public_path__ + "static/media/menu-vault.39c3f0323f3be388c3b842bbf9e52cf6.svg";
export { ForwardRef as ReactComponent };